<template>
  <div class="top-bar-container">
    <wrap-container class="w100">
      <div class="inner-container">
        <div class="logo">
          <img src="@/assets/img/logo.svg" alt="BBVA" />
        </div>
        <div class="modulo">
          <p v-html="config.modulo" />
        </div>
      </div>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "TopBar",
  components: { WrapContainer }
};
</script>

<style scoped>
div.top-bar-container {
  background: #043263;
  color: white;
  position: fixed;
  width: 100%;
  z-index: 9999;
  padding: 0 17px;
}

div.inner-container {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.logo img {
  height: 25px;
}

div.modulo {
  text-align: right;
}

p {
  font-size: 16px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin: 0;
}

@media screen and (max-width: 420px) {
  div.logo img {
    height: 23px;
  }
  p {
    font-size: 12px;
  }
}
</style>
